// Structured data (JSON-LD) helpers for Shiny-Cleaning

const SITE_URL = 'https://shiny-cleaning.nl';

export const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'AutoDetailing',
  '@id': `${SITE_URL}/#business`,
  name: 'Shiny-Cleaning',
  description:
    'Shiny-Cleaning is een premium autodetailingbedrijf in Deventer, opgericht in 2014. Wij bieden detailing, lakcorrectie, keramische coating, PPF, ramen tinten, auto wrappen, interieurreiniging en detailing aan huis in Deventer en omgeving.',
  foundingDate: '2014',
  image: `${SITE_URL}/og-image.jpg`,
  logo: `${SITE_URL}/logo.png`,
  url: SITE_URL,
  telephone: '+31-570-238004',
  email: 'info@shiny-cleaning.nl',
  priceRange: '€€€',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Deventer',
    addressRegion: 'Overijssel',
    addressCountry: 'NL',
  },
  areaServed: [
    { '@type': 'City', name: 'Deventer' },
    { '@type': 'City', name: 'Apeldoorn' },
    { '@type': 'City', name: 'Zutphen' },
    { '@type': 'City', name: 'Raalte' },
    { '@type': 'City', name: 'Zwolle' },
    { '@type': 'AdministrativeArea', name: 'Overijssel' },
    { '@type': 'AdministrativeArea', name: 'Gelderland' },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+31-570-238004',
    email: 'info@shiny-cleaning.nl',
    contactType: 'customer service',
    areaServed: 'NL',
    availableLanguage: ['nl', 'en'],
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Autodetailing diensten',
    itemListElement: [
      'Detailing',
      'Keramische coating',
      'PPF — Paint Protection Film',
      'Lakcorrectie',
      'Ramen tinten',
      'Auto wrappen',
      'Detailing aan huis',
    ].map((s) => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name: s } })),
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '09:00',
      closes: '16:00',
    },
  ],
  sameAs: [
    'https://www.instagram.com/shiny.cleaning.nl/',
  ],
};

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Shiny-Cleaning',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  foundingDate: '2014',
  sameAs: ['https://www.instagram.com/shiny.cleaning.nl/'],
};

export const WEBSITE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Shiny-Cleaning',
  inLanguage: 'nl-NL',
  publisher: { '@id': `${SITE_URL}/#organization` },
};

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const serviceSchema = ({ name, description, image, price, slug }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  name: `${name} — Shiny-Cleaning`,
  description,
  image,
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'City', name: 'Deventer' },
    { '@type': 'City', name: 'Zutphen' },
    { '@type': 'City', name: 'Raalte' },
    { '@type': 'City', name: 'Apeldoorn' },
    { '@type': 'AdministrativeArea', name: 'Overijssel' },
  ],
  url: `${SITE_URL}/diensten/${slug}`,
  offers: price
    ? {
        '@type': 'Offer',
        priceCurrency: 'EUR',
        price: String(price).replace(/[^\d]/g, '') || undefined,
        availability: 'https://schema.org/InStock',
        url: `${SITE_URL}/diensten/${slug}`,
      }
    : undefined,
});

export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((it) => ({
    '@type': 'Question',
    name: it.q,
    acceptedAnswer: { '@type': 'Answer', text: it.a },
  })),
});

export const localServiceSchema = ({ city, path, serviceType = 'Auto detailing' }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType,
  name: `${serviceType} ${city} — Shiny-Cleaning`,
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: { '@type': 'City', name: city },
  url: `${SITE_URL}${path}`,
});

export const mobileDetailingSchema = ({ name, description }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Mobiele autodetailing aan huis',
  name: `${name} — Shiny-Cleaning`,
  description,
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'City', name: 'Deventer' },
    { '@type': 'City', name: 'Apeldoorn' },
    { '@type': 'City', name: 'Zutphen' },
    { '@type': 'City', name: 'Raalte' },
    { '@type': 'AdministrativeArea', name: 'Overijssel' },
    { '@type': 'AdministrativeArea', name: 'Gelderland' },
  ],
  url: `${SITE_URL}/detailing-aan-huis`,
});
